/**
 * The sponsor's status — E-ECP.2.1, and the first gate on the whole route.
 *
 * The applicant's partner must be a British or Irish citizen, present and
 * settled, in the UK with protection status, in the UK with limited leave
 * under Appendix EU, in the UK with limited leave as a worker or business
 * person under Appendix ECAA, or in the UK with permission as a stateless
 * person. If they hold none of those, there is no partner visa on this route
 * and no amount of income or savings changes it — which is why this is asked
 * before any figures (ADR-0022).
 *
 * `none_of_these` is handled as an out-of-scope flag rather than NOT_MET, so
 * the engine short-circuits and refers instead of computing a requirement
 * that cannot help.
 */
import type { EvaluatePredicate } from "./predicate.js";

const QUALIFYING = new Set([
  "british_or_irish",
  "settled",
  "protection_status",
  "eu_settlement_limited_leave",
  "ecaa_worker_or_business",
  "stateless_permission",
]);

export const sponsor_status: EvaluatePredicate = (facts) => {
  const status = facts.sponsor.status;

  if (status === null) {
    return {
      status: "PENDING_EVIDENCE",
      notes: ["The partner's citizenship or immigration status is needed."],
    };
  }

  if (QUALIFYING.has(status)) {
    return { status: "MET", value: status };
  }

  // Reached only if the out-of-scope short-circuit is bypassed; kept honest
  // rather than silently passing.
  return {
    status: "NOT_MET",
    value: status,
    notes: [
      "The rules ask that the applicant's partner holds one of the listed statuses. This route is not available otherwise.",
    ],
  };
};
